class MessageEncryptStatus {
  processMessage(message) {
    // Logic xử lý tin nhắn bot
    console.log("Processing bot message:", message); // eslint-disable-line no-console
  }
}

export default MessageEncryptStatus;
